module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAASFBMVEUAAAD6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYn6zYmdX+VgAAAAF3RSTlMAIuH36ijJmYlXDAjiMBfRnJvQQxpAPjsk9kMAAADYSURBVDjLjVNZFoMgDAybCAIutc39b9pWealBkc4PPGaykAV+8M52WindWefhDDErJKhZFPTQZ5ok/cDMFzxhOTiJGi+gI9kTXyhEjr9gBeOeR49V9FsAVReob5AZbzABeHLwiGG/hPgkFx4cqQ2IsPECDD06sHSXYlOEzyHp0UKHTCE5jx1oZIp1ZTxqYJ+UCSBJ9tGmoAyRUhmiTFKWSVrO05FhWaF2QrJCHUttsqE0r0OpYbptVqvd5p+BgWGsj1xraJtjTxDjhX/RXD0Ow5Z3MkS01v8Nl3Y+PRGKa6sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme_black/del.png
// module id = OX1S
// module chunks = 1